<script lang="ts">
  import KeyboardHint from '$icons/KeyboardHintIcon.svelte';
  import { createEventDispatcher } from 'svelte';
  import Logo from '$icons/Logo.svelte';
  import Modal from '../Modals/SmallModal/Modal.svelte';
    import Button from '../common/buttons/Button.svelte';

  const dispatch = createEventDispatcher();
</script>

<Modal on:ModalClose>
  <div slot="content" class="w-[360px] h-[460px] flex flex-col gap-16 items-center justify-center">
    <div class="flex flex-col gap-3 items-center">
      <Logo width="112px" height="92" />
      <span class="text-xs w-min border rounded-md border-garden-grey-300 text-garden-grey-400 px-1.5"
        >BETA</span
      >
    </div>

    <div class="flex flex-col gap-4 text-center">
      <p class="text-garden-grey-800 font-bold text-2xl">Welcome to the Garden Beta!</p>
      <p class="text-garden-grey-600 font-normal">
        Welcome to the Garden! We're thrilled to have you as one of our early users. If you come
        across any bugs, please send us an <a
          class="text-brand-green-50 font-bold hover:underline"
          href="mailto:support@thegarden.gg">email</a
        >
        or reach out to us on
        <a class="text-brand-green-50 font-bold hover:underline" href="https://discord.gg/w7G2gGDSUF"
          >Discord</a
        > so we can enhance your experience here in the Garden. Lets grow together!
      </p>
    </div>
  </div>

  <div slot="footer" class="flex items-center justify-center">
    <Button
      primary
      iconRight={KeyboardHint}
      label="Enter The New Garden"
      clickOnKey="Enter"
      on:click={() => {
        dispatch('ModalClose');
      }}
    />
  </div>
</Modal>
